import * as React from 'react';
export const stableSvg = React.forwardRef(function stableSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: '#4B7EDE',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M11.622 23.586c-.058-.167-.226-.288-.405-.26-.847.127-1.734.143-2.592.048-.276-.03-.482.248-.395.504l1.311 3.826c.051.149.19.253.35.262.914.051 1.818.044 2.708-.019a.384.384 0 0 0 .344-.504l-1.322-3.857Zm16.356-9.321-1.31-3.826a.392.392 0 0 0-.35-.262c-3.529-.196-6.993.459-10.084 2.025a.398.398 0 0 1-.558-.218l-.274-.798a.381.381 0 0 1 .192-.462c3.03-1.562 6.425-2.243 9.89-2.098a.386.386 0 0 0 .39-.505l-1.311-3.825a.39.39 0 0 0-.35-.262c-3.572-.2-7.078.474-10.198 2.084a.381.381 0 0 0-.191.461l.668 1.949a.38.38 0 0 1-.192.461c-3.03 1.564-6.424 2.244-9.89 2.099a.386.386 0 0 0-.39.505l1.312 3.825a.39.39 0 0 0 .35.262c3.528.197 6.992-.458 10.084-2.025a.398.398 0 0 1 .557.218l.274.798a.381.381 0 0 1-.191.462c-3.031 1.563-6.425 2.243-9.891 2.098a.386.386 0 0 0-.39.505l1.312 3.825a.39.39 0 0 0 .35.262c3.572.2 7.077-.474 10.198-2.083a.381.381 0 0 0 .191-.462l-.668-1.948a.38.38 0 0 1 .192-.462c3.03-1.563 6.424-2.243 9.89-2.098a.386.386 0 0 0 .39-.505h-.002Z',
      }),
    ),
  );
});
stableSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stable = {
  category: 'brand',
  colorable: false,
  name: 'stable',
  svg: stableSvg,
};
